import lodash from "lodash"
_ = lodash;
export const globalHelper = {
    methods: {
        IsNotNullOrUndefined(context, string = "") {
            if (string === "") {
                return context !== undefined && context !== null;
            }
            let object = _.get(context, string, null);
            if (object === null) {
                //Is null or undefined
                return false;
            }
            return true;
        },
        clog(...values){
            var stackTraceString;
            try {
                throw new Error('');
            }
            catch (error) {

                stackTraceString = error.stack || '';
            }
            let stackTraceArray = stackTraceString.split('\n').map(function (line) { return line.trim(); });
            stackTraceArray = stackTraceArray.splice(stackTraceArray[0] == 'Error' ? 2 : 1);

            let callingMethod = stackTraceArray[0].substring(0, stackTraceArray[0].indexOf('('));
            callingMethod = callingMethod.replace(/^\s+|\s+$/g, '');

            let componentName = this.$options?.name || "UnnamedComponent";
            console.log(
                `${componentName}.(ts|vue)\n`,
                `fn: ${callingMethod}\n`,
                ...values
            );
        },
        IsNullOrUndefined(context, string = "") {
            return !this.IsNotNullOrUndefined(context, string);
        },
        DateIsInThePast(date) {
            const rightNow = Date.now();
            if (date instanceof Date) {
                return date < rightNow;
            }
            else if ((typeof date) === "string") {
                return Date.parse(date) < rightNow;
            }
        },
        DateIsInTheFuture(date) {
            return !this.DateIsInThePast(date);
        },
        RemoveDateSpecialChars(str){
            let specialCharsRegex = /\/|\.|\\|\-/gi  
            var result = str.replace(specialCharsRegex ,"");
            return result;
        },
        Any(context, string = ""){
            if(this.IsNullOrUndefined(context, string)){
                return false;
            }
            
            let object = context;
            if(string !== ""){
                object = _.get(context, string, null);
            }
    
            if(object.length && object.length > 0){
                return true;
            }
    
            return false;
        }
    }
}